'use strict';

var getColorMix$1 = require('../../../../../../../../_virtual/getColorMix.cjs');
require('./extractAlpha.cjs');
require('./extractHex.cjs');
var extractAlpha$1 = require('../../../../../../../../_virtual/extractAlpha.cjs');
var extractHex$1 = require('../../../../../../../../_virtual/extractHex.cjs');

var extractAlpha = extractAlpha$1.__exports;
var extractHex = extractHex$1.__exports;

/**
 * returns an oklab color-mix. Used for Opacity overlay effect
 */ const getColorMix = (defaultHex, effectAlphaHex)=>{
    const effectHex = extractHex.extractHex(effectAlphaHex);
    const effectAlpha = extractAlpha.extractAlpha(effectAlphaHex);
    return `color-mix(in oklab, ${defaultHex} 100%, ${effectHex} ${effectAlpha}%)`;
};

getColorMix$1.__exports.getColorMix = getColorMix;

module.exports = getColorMix$1.__exports;
//# sourceMappingURL=getColorMix.cjs.map
